import Slider from './slider-block';
import Map from './map-block';
import Accordion from './accordion-blocks';

export default () => {
  Accordion();
  Map();
};


// WEBPACK FOOTER //
// ./scripts/blocks/gutenberg-blocks.js